export default import.meta.ROLLUP_FILE_URL_b28c9ff7;